import { CategoryType, DataType, ItemType } from '../types/lib/types';
import { walkCategories } from './urlEncoding';


/* ****************
 * category直下のdataとcategoryを取得
 * ****************/
export const getBelongingLayers = (items: {[key: string]: DataType|CategoryType}) => {

  return [...walkCategories(items)].map((item: ItemType) => {
    return item.id;
  });

};
